export default {
    "driver_performance_historyTooltip_noHistory": "No hay historial disponible",
    "driver_performance_historyTooltip_status": "Estado",
    "driver_performance_historyTooltip_statusEvaluation": "Evaluación",
    "driver_performance_historyTooltip_statusEscalation": "Escalación",
    "driver_performance_historyTooltip_effectiveDate": "Fecha Efectiva",
    "driver_performance_historyTooltip_metric": "Métrica",
    "driver_performance_historyTooltip_measure": "Medida",
    "driver_performance_historyTooltip_target": "Objetivo",
    "driver_performance_historyTooltip_byDistance": "Por Distancia",
    "driver_performance_historyTooltip_avgevents": "Eventos Promedio",
    "driver_performance_historyTooltip_riskscore": "Puntuación de Riesgo",
    "driver_performance_historyTooltip_events": "Eventos",
    "driver_performance_historyTooltip_totaldistance": "Distancia Total"
};
